import { _ } from "libs";

import React, { useRef } from "react";
import { Profile } from "../types";
import { resendConfirmationEmail, flash } from "../actions";

const EmailConfirm = ({ profile }: { profile?: Profile }) => {
	if (!profile) {
		return null;
	}

	if (!profile.email || profile.emailValid) {
		return null;
	}

	const node = useRef();

	const onClick = () => {
		resendConfirmationEmail();
		flash(_("confirmEmail.resentEmailConfirmation"));
		//@ts-ignore
		node.current.remove();
	};

	return (
		<div className="stickyAlerts">
			<div className="stickyAlert" ref={node}>
				<h5>{_("confirmEmail.heading")}</h5>
				<p>
					{_("confirmEmail.text")}
					&nbsp;
					<a className="plain" onClick={onClick}>
						{_("confirmEmail.sendItAgainBtn")}
					</a>
				</p>
			</div>
		</div>
	);
};

export default EmailConfirm;
